/* Accordion = (function() {
    function Accordion() {
      jQuery('.accordion.headings').each(function() {
        return jQuery(this).add(jQuery(this).next('.accordion.content')).wrapAll("<div class='accordion-wrapper'/>");
      });
      general_scroll_to_active_item = false;

      jQuery('.accordion.headings li').wrapInner('<div class="trigger"></div>');
      jQuery('.accordion.headings li .trigger').append('<div class="bg"></div>');
      jQuery('.accordion-wrapper').each(function() {
        var accordion_content, accordion_heading;
        accordion_heading = jQuery(this).find('.accordion.headings > li');
        accordion_content = jQuery(this).find('.accordion.content > li');
        accordion_heading.first().addClass('active');
        accordion_content.each(function(index) {
          var content;
          content = jQuery('<div class="content">' + jQuery(this).html() + '</div>');
          return content.appendTo(accordion_heading.eq(index));
        });
        accordion_content.remove();
        jQuery(this).find('.content').first().show();
        return jQuery(this).find('.trigger').on("click", function() {
          var panels, this_panel;
          panels = jQuery(this).closest(".accordion").find('.content');
          this_panel = jQuery(this).closest("li").find(".content");
          panels.not(this_panel).slideUp(200);
          this_panel.slideDown(200, function() {
            if (general_scroll_to_active_item) {
              return jQuery('html, body').animate({
                scrollTop: this_panel.offset().top - 100
              });
            }
          });
          jQuery(this).closest(".accordion").find("li").removeClass("active");
          return jQuery(this).closest("li").addClass("active");
        });
      });
    }

    return Accordion;

  })();
*/

jQuery(document).ready(function(){

   if( jQuery('.product-gallery').length > 0 ) {
     jQuery('.product-gallery').owlCarousel({
        loop:false,
        margin:10,
        nav:true,
        navText: ["<svg viewBox='0 0 100 100'><path d='M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z' class='arrow'></path></svg>", "<svg viewBox='0 0 100 100'><path d='M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z' class='arrow' transform='translate(100, 100) rotate(180) '></path></svg>"],
        responsive:{
            0:{
                items:2
            },
            768:{
                items:3
            },
            992:{
                items:4
            },
            1200:{
                items:5
            }
        }
      });
   }

   if( jQuery('.carousel-image-text-founder').length > 0 ) {
     jQuery('.carousel-image-text-founder').owlCarousel({
       nav: false,
       dots: true,
       items: 1
     });
   }

   if( jQuery('.carousel-image-founder').length > 0 ) {
     jQuery('.carousel-image-founder').owlCarousel({
       nav: true,
       dots: false,
       navText: ['<svg height="70px" width="70px" viewBox="0 0 24 24" fill="none" x="0px" y="0px"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.3536 5.64645C15.5488 5.84171 15.5488 6.15829 15.3536 6.35355L9.70711 12L15.3536 17.6464C15.5488 17.8417 15.5488 18.1583 15.3536 18.3536C15.1583 18.5488 14.8417 18.5488 14.6464 18.3536L8.64645 12.3536C8.45118 12.1583 8.45118 11.8417 8.64645 11.6464L14.6464 5.64645C14.8417 5.45118 15.1583 5.45118 15.3536 5.64645Z" fill="black"/></svg>', '<svg height="70px" width="70px" viewBox="0 0 24 24" fill="none" x="0px" y="0px"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.64645 5.64645C8.45118 5.84171 8.45118 6.15829 8.64645 6.35355L14.2929 12L8.64645 17.6464C8.45118 17.8417 8.45118 18.1583 8.64645 18.3536C8.84171 18.5488 9.15829 18.5488 9.35355 18.3536L15.3536 12.3536C15.5488 12.1583 15.5488 11.8417 15.3536 11.6464L9.35355 5.64645C9.15829 5.45118 8.84171 5.45118 8.64645 5.64645Z" fill="black"/></svg>'],
       items: 1
     });
   }

   if( jQuery('.carousel-image-story').length > 0 ) {
     jQuery('.carousel-image-story').owlCarousel({
       nav: true,
       loop:true,
       items:3,
       autoWidth:true,
       navText: ['<svg height="70px" width="70px" viewBox="0 0 24 24" fill="none" x="0px" y="0px"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.3536 5.64645C15.5488 5.84171 15.5488 6.15829 15.3536 6.35355L9.70711 12L15.3536 17.6464C15.5488 17.8417 15.5488 18.1583 15.3536 18.3536C15.1583 18.5488 14.8417 18.5488 14.6464 18.3536L8.64645 12.3536C8.45118 12.1583 8.45118 11.8417 8.64645 11.6464L14.6464 5.64645C14.8417 5.45118 15.1583 5.45118 15.3536 5.64645Z" fill="black"/></svg>', '<svg height="70px" width="70px" viewBox="0 0 24 24" fill="none" x="0px" y="0px"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.64645 5.64645C8.45118 5.84171 8.45118 6.15829 8.64645 6.35355L14.2929 12L8.64645 17.6464C8.45118 17.8417 8.45118 18.1583 8.64645 18.3536C8.84171 18.5488 9.15829 18.5488 9.35355 18.3536L15.3536 12.3536C15.5488 12.1583 15.5488 11.8417 15.3536 11.6464L9.35355 5.64645C9.15829 5.45118 8.84171 5.45118 8.64645 5.64645Z" fill="black"/></svg>'],
       responsive: {
        0:{
          items: 1,
          nav: false,
          dots: true,
          autoWidth:false,
        },
        576:{
          items: 2,
          autoWidth: false,
          dots: false,
          margin: 20
        },
        768:{
          items: 3,
          nav: true,
          dots: false,
          loop: true,
          margin: 20,
          autoWidth: true,

        }
    }
     });
   }


   jQuery('ul.tabs-custom li').click(function(){
		var tab_id = jQuery(this).attr('data-tab');

		jQuery('ul.tabs-custom li').removeClass('current');
		jQuery('.tab-content').removeClass('current');

		jQuery(this).addClass('current');
		jQuery("#" + tab_id).addClass('current');
	});

  jQuery('[data-product-option-button]').on('click', function(e) {
    e.preventDefault();

    jQuery('[data-product-option-button]').removeClass('product-card__swatch--active');
    jQuery(this).addClass('product-card__swatch--active');

    var index = jQuery(this).data('index');
    var color = jQuery(this).data('color');
    var option_name = jQuery(this).attr('title');

    jQuery(this).parents('.product-detail__options').find('.selector-wrapper label span').text(option_name);

    jQuery('[data-single-option-selector]').prop('selectedIndex', index).trigger('change');

    if( color ) {
      jQuery('.product-thumbnails').removeClass('selected');
      jQuery('#ProductThumbs-' + color).find('a:first-child').trigger('click');
      jQuery('#ProductThumbs-' + color).addClass('selected');
    }

  });

  if( jQuery('#product-images-mobile').length > 0 ) {
    var owl = jQuery("#product-images-mobile");

    owl.on('translated.owl.carousel', function(event) {

      var image_index = event.item.index;
      var image_item = jQuery('.owl-item').get(image_index);

      var image_color = jQuery(image_item).find('[data-color]').data('color');

      var active_item = jQuery('.product-card__swatch--active');
      var active_color = jQuery(active_item).data('color');

      if( image_color != active_color) {
        var select_item = jQuery('.product-card__swatch[data-color="' + image_color + '"]');
        jQuery('[data-product-option-button]').removeClass('product-card__swatch--active');
        jQuery(select_item).addClass('product-card__swatch--active');
        console.log('------');

        console.log('colocando la clase');
        jQuery('body').addClass('carousel-swiping');

        var select_index = jQuery(select_item).data('index');
        var option_name = jQuery(select_item).attr('title');

        jQuery(select_item).parents('.product-detail__options').find('.selector-wrapper label span').text(option_name);

        jQuery('[data-single-option-selector]').prop('selectedIndex', select_index).trigger('change');

      }
    });



  }

});

jQuery(window).on('load', function() {
  if( jQuery('#product-images-mobile').length > 0 ) {
    jQuery('[data-single-option-selector]').trigger('change');
  }
});
